import React, { useMemo } from "react";
import { Link } from "react-router-dom";

const artformColors = {
  music: "#367591",
  sound: "#009FE3",
  film: "#FBF299",
  art: "#E6007E",
  environment: "#6EBC86",
  writing: "#7B6A58",
  activism: "#E24259",
  performance: "#725283",
  video: "#ABD194",
  vr: "#4D4C4C",
};

function FieldNoteCard({ fieldNote }) {
  const {
    id,
    url,
    author_url: authorUrl,
    card_image: cardImage,
    artforms,
    title,
    name,
  } = fieldNote;

  const artformTags = useMemo(() => {
    if (!artforms) return null;

    return artforms
      .split(",")
      .map((artform) => artform.trim().toLowerCase())
      .filter(Boolean)
      .map((artform) => (
        <span
          key={artform}
          style={{
            backgroundColor: artformColors[artform] || "#888",
            color: "white",
            borderRadius: 8,
            padding: "4px 8px",
            fontSize: "0.8rem",
            whiteSpace: "nowrap",
          }}
        >
          {artform}
        </span>
      ));
  }, [artforms]);

  const authorColorClasses = [
    "txt-gradient-1",
    "txt-gradient-2",
    "txt-gradient-3",
    "txt-gradient-4",
    "txt-gradient-5",
    "txt-gradient-6",
  ];
  const authorClass = authorColorClasses[Math.abs(Number(id) || 0) % authorColorClasses.length];

  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="package-card-beta fieldnote-card">
      <div className="package-thumb fieldnote-card-thumb">
        <Link to={url} onClick={scrollTop} aria-label={`Read ${title} by ${name}`}>
          {cardImage ? (
            <img src={cardImage} alt={`${title} by ${name}`} loading="lazy" />
          ) : (
            <div className="fieldnote-card-placeholder" aria-hidden="true" />
          )}
        </Link>

        {artformTags && <div className="artformcontainer">{artformTags}</div>}
      </div>

      <div className="package-card-body">
        <h3 className="p-card-title">
          <Link to={url} onClick={scrollTop}>{title}</Link>
          {" by "}
          {authorUrl ? (
            <Link className="fieldnote-card-author-link" to={authorUrl} onClick={scrollTop}>
              <span className={authorClass}>{name}</span>
            </Link>
          ) : (
            <span className={authorClass}>{name}</span>
          )}
        </h3>

        <div className="p-card-bottom fieldnote-card-bottom">
          <div className="book-btn">
            <Link to={url} onClick={scrollTop}>
              Read <i className="bx bxs-right-arrow-alt" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FieldNoteCard;
